import skyovalbackground from "../../../assets/images/skyovalbackground.png";
import skybackgrounddesktop from "../../../assets/images/skybackgrounddesktop.png";
import "./Cids.scss";
import slr from "../../../assets/images/slr.png";
import extremeheat from "../../../assets/images/extremeheat.png";
import extremeprecipitation from "../../../assets/images/extremeprecipitation.png";
import { useEffect, useRef } from "react";
import * as $ from "jquery";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";

const SCROLL_CONFIG = {
  mobile: {
    cidTitle: { min: 0.3, max: 0.6 },
    firstcarousel: { min: 0.35, max: 0.75 },
  },
  desktop: {
    cidTitle: { min: 0.35, max: 0.65 },
    carouselanimatedslider: { min: 0.5, max: 0.9 },
  },
};

const Cids = () => {
  const slrElement = useRef();
  const heatElement = useRef();
  const precipElement = useRef();
  const slrBullet = useRef();
  const heatBullet = useRef();
  const precipBullet = useRef();
  const cidTitle = useRef();
  const firstcarousel = useRef();
  const carouselanimatedslider = useRef();

  /* useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const documentHeight = document.body.scrollHeight;
      const config =
        window.innerWidth < 577 ? SCROLL_CONFIG.mobile : SCROLL_CONFIG.desktop;

      const checkRange = (min, max) =>
        scrollPosition >= min * documentHeight &&
        scrollPosition <= max * documentHeight;

      const updateStyle = (element, inRange, stylesOn, stylesOff) => {
        if (element) {
          const styles = inRange ? stylesOn : stylesOff;
          Object.keys(styles).forEach((property) => {
            element.style[property] = styles[property];
          });
        }
      };

      // Handle cidTitle
      updateStyle(
        cidTitle.current,
        checkRange(config.cidTitle.min, config.cidTitle.max),
        { opacity: "1", transition: "all 0.7s" },
        { opacity: "0", transition: "all 0.7s" },
      );

      // Handle firstcarousel (mobile only)
      if (window.innerWidth < 577) {
        updateStyle(
          firstcarousel.current,
          checkRange(config.firstcarousel.min, config.firstcarousel.max),
          { transform: "scale(1)", transition: "all 0.7s" },
          { transform: "scale(0)", transition: "all 0.7s" },
        );
      }

      // Handle carouselanimatedslider (desktop only)
      if (window.innerWidth >= 577) {
        updateStyle(
          carouselanimatedslider.current,
          checkRange(
            config.carouselanimatedslider.min,
            config.carouselanimatedslider.max,
          ),
          { opacity: "1", left: "0%", transition: "all 0.7s" },
          { opacity: "0", left: "100%", transition: "all 0.7s" },
        );
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); */

  return (
    <div className="cids">
      <img
        className="skyovalbackground mobile"
        src={skyovalbackground}
        alt="skyovalbackground"
      />
      <img
        className="skyovalbackground desktop"
        src={skybackgrounddesktop}
        alt="skyovalbackground"
      />
      <div className="container cid-content">
        <div className="title" ref={cidTitle}>
          Lagos is highly exposed to <span>Climatic Impact Drivers (CIDs)</span>
        </div>

        <OwlCarousel className="owl-theme mobile" margin={0} nav items={1}>
          <div ref={firstcarousel} className="item cid-carousel">
            <div className="custom-row mobile">
              <div className="cid-title mobile">Sea Level Rise</div>
              <img
                src={slr}
                alt="slr"
                className="cid-img mobile"
                ref={slrElement}
              />
            </div>
            <div className="custom-col mobile">
              <div ref={slrBullet} className="cid-driver-bullet-parent mobile">
                <div className="cid-driver-title">Associated Hazards</div>
                <div className="cid-driver-bullet">
                  &bull; Projected to worsen rapidly over the years (31-39cm
                  from 2000-2080)
                </div>
                <div className="cid-driver-bullet">
                  &bull; 65% of population are affected
                </div>
                <div className="cid-driver-bullet">
                  &bull; ~7000 affected assets exposed with a value of $86bn
                </div>
              </div>
            </div>
          </div>
          <div className="item cid-carousel">
            <div className="custom-row mobile">
              <div className="cid-title mobile">Extreme Temperature Rise</div>
              <img
                src={extremeheat}
                alt="extreme-heat"
                className="cid-img mobile"
                ref={heatElement}
              />
            </div>
            <div className="custom-col mobile">
              <div ref={heatBullet} className="cid-driver-bullet-parent mobile">
                <div className="cid-driver-title">Associated Hazards</div>
                <div className="cid-driver-bullet">
                  &bull; 25+ additional days of extreme heat annually
                </div>
                <div className="cid-driver-bullet">
                  &bull; 20% of population projected to be affected by heatwaves
                  by 2080
                </div>
                <div className="cid-driver-bullet">
                  &bull; 10 in every 100.000 people die of heat related causes
                  by 2080
                </div>
              </div>
            </div>
          </div>
          <div className="item cid-carousel">
            <div className="custom-row mobile">
              <div className="cid-title mobile">Extreme Rainfall</div>
              <img
                src={extremeprecipitation}
                alt="extreme-precipitation"
                className="cid-img mobile"
                ref={precipElement}
              />
            </div>
            <div className="custom-col mobile">
              <div
                ref={precipBullet}
                className="cid-driver-bullet-parent mobile"
              >
                <div className="cid-driver-title">Associated Hazards</div>
                <div className="cid-driver-bullet">
                  &bull; Erratic rainfall predicted to increase about 40mm per
                  year in Nigeria
                </div>
                <div className="cid-driver-bullet">
                  &bull; 33% increase in days of extreme rainfall by 2080
                </div>
              </div>
            </div>
          </div>
        </OwlCarousel>
        <div ref={carouselanimatedslider} className="carousel-animated-slider">
          <OwlCarousel className="owl-theme desktop" margin={0} nav items={3}>
            <div className="item cid-carousel desktop">
              <div className="custom-row desktop">
                <div className="cid-title desktop">Sea Level Rise</div>
                <img src={slr} alt="slr" className="cid-img desktop" />
              </div>
              <div className="custom-col desktop">
                <div className="cid-driver-bullet-parent desktop">
                  <div className="cid-driver-title desktop">
                    Associated Hazards
                  </div>
                  <div className="cid-driver-bullet desktop">
                    &bull; Projected to worsen rapidly over the years (31-39cm
                    from 2000-2080)
                  </div>
                  <div className="cid-driver-bullet desktop">
                    &bull; 65% of population are affected
                  </div>
                  <div className="cid-driver-bullet desktop">
                    &bull; ~7000 affected assets exposed with a value of $86bn
                  </div>
                </div>
              </div>
            </div>
            <div className="item cid-carousel desktop">
              <div className="custom-row desktop">
                <div className="cid-title desktop">
                  Extreme Temperature Rise
                </div>
                <img
                  src={extremeheat}
                  alt="extreme-heat"
                  className="cid-img desktop"
                />
              </div>
              <div className="custom-col desktop">
                <div className="cid-driver-bullet-parent desktop">
                  <div className="cid-driver-title desktop">
                    Associated Hazards
                  </div>
                  <div className="cid-driver-bullet desktop">
                    &bull; 25+ additional days of extreme heat annually
                  </div>
                  <div className="cid-driver-bullet desktop">
                    &bull; 20% of population projected to be affected by
                    heatwaves by 2080
                  </div>
                  <div className="cid-driver-bullet desktop">
                    &bull; 10 in every 100.000 people die of heat related causes
                    by 2080
                  </div>
                </div>
              </div>
            </div>
            <div className="item cid-carousel desktop">
              <div className="custom-row desktop">
                <div className="cid-title desktop">Extreme Rainfall</div>
                <img
                  src={extremeprecipitation}
                  alt="extreme-precipitation"
                  className="cid-img desktop"
                />
              </div>
              <div className="custom-col desktop">
                <div className="cid-driver-bullet-parent desktop">
                  <div className="cid-driver-title desktop">
                    Associated Hazards
                  </div>
                  <div className="cid-driver-bullet desktop">
                    &bull; Erratic rainfall predicted to increase about 40mm per
                    year in Nigeria
                  </div>
                  <div className="cid-driver-bullet desktop">
                    &bull; 33% increase in days of extreme rainfall by 2080
                  </div>
                </div>
              </div>
            </div>
          </OwlCarousel>
        </div>
      </div>
    </div>
  );
};

export default Cids;
